import { useApi } from '@omnipresentgroup/api';
import type {
  GetEmployeesSimplifiedAPIResponse,
  TimesheetsSystem,
} from '@omnipresentgroup/types';
import { useQuery } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

type Selector<T> = (data: GetEmployeesSimplifiedAPIResponse) => T;

export const useGetManagerEmployeesSimplified = <
  T = GetEmployeesSimplifiedAPIResponse,
>({
  companyId,
  timesheetsSystem,
  enabled,
  select,
}: {
  companyId: string;
  timesheetsSystem?: TimesheetsSystem;
  enabled?: boolean;
  select?: Selector<T>;
}) => {
  const { GET } = useApi();

  return useQuery({
    queryKey: [API_PATH, companyId, timesheetsSystem],
    queryFn: () =>
      GET<GetEmployeesSimplifiedAPIResponse>(
        `${API_BASE}/${API_PATH}/company/${companyId}`,
        {},
        {
          simplified: 'true',
          ...(timesheetsSystem
            ? { 'timesheets-system': timesheetsSystem }
            : {}),
        },
      ),
    enabled,
    select,
  });
};
